var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 63.92 101.543"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3689",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "M4.655 33.932a4.5 4.5 0 0 0 .035 6.315l31.521 31.946a4.46 4.46 0 0 0 6.314-.037 4.5 4.5 0 0 0-.037-6.312L10.967 33.896a4.46 4.46 0 0 0-6.312.036",
  "data-name": "Tracciato 3588"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "m60.365 91.486-24.221 4.731-3.72-19.028-17.032-24.592 36-7.031Z",
  "data-name": "Tracciato 3589"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "M5.083 48.288a4.5 4.5 0 0 0 .036 6.313l31.522 31.947a4.46 4.46 0 0 0 6.314-.037 4.5 4.5 0 0 0-.037-6.313L11.397 48.252a4.457 4.457 0 0 0-6.314.036",
  "data-name": "Tracciato 3590"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "M1.692 16.342a4.5 4.5 0 0 0 .036 6.313l30.371 30.743a4.456 4.456 0 0 0 6.313-.036 4.493 4.493 0 0 0-.037-6.312L8.006 16.306a4.457 4.457 0 0 0-6.314.036",
  "data-name": "Tracciato 3591"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 2239",
  transform: "translate(10.056)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37.628,
  height: 68.005,
  fill: "#a5a093",
  "data-name": "Rettangolo 2008",
  rx: 5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  d: "M3.557 6.219h30.514a.25.25 0 0 1 .248.248v54.452a.247.247 0 0 1-.247.247H3.557a.247.247 0 0 1-.247-.247V6.466a.247.247 0 0 1 .247-.247",
  "data-name": "Rettangolo 2009"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dbd7d0",
  d: "M13.11 1.835h11.408a.563.563 0 0 1 .563.563.56.56 0 0 1-.562.562h-11.41a.56.56 0 0 1-.562-.562.563.563 0 0 1 .563-.563",
  "data-name": "Rettangolo 2010"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dbd7d0",
  fillRule: "evenodd",
  d: "M18.814 62.578a1.9 1.9 0 1 0 1.9 1.9 1.9 1.9 0 0 0-1.9-1.9",
  "data-name": "Tracciato 3592"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "M2.126 45.353a4.483 4.483 0 0 0 .035 6.313l5.915 5.873a4.476 4.476 0 0 0 6.313-.036 4.48 4.48 0 0 0-.036-6.313L8.44 45.316a4.473 4.473 0 0 0-6.314.037",
  "data-name": "Tracciato 3593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "M1.281 30.585a4.48 4.48 0 0 0 .035 6.312l5.037 5a4.477 4.477 0 0 0 6.313-.035 4.48 4.48 0 0 0-.036-6.312l-5.037-5a4.47 4.47 0 0 0-6.312.035",
  "data-name": "Tracciato 3594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9e998f",
  fillRule: "evenodd",
  d: "m62.134 83.577-30.6 5.978 1.369 11.988a65.1 65.1 0 0 0 31.021-8.827Z",
  "data-name": "Tracciato 3595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  fillRule: "evenodd",
  d: "m53.694 73.025-3.095.6-.412-3.9-3.32-31.267c-.562-5.295 2.108-7.42 5.3-8.452 1.76-.568 2.18-1.056 2.351.558l3.8 35.789a6.14 6.14 0 0 1-4.624 6.672",
  "data-name": "Tracciato 3596"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#a5a093",
  "data-name": "Raggruppa 2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.718 28.204a.28.28 0 0 0-.3.041l-2.393 2.054h-2.368a.28.28 0 0 0-.279.278v3.229a.28.28 0 0 0 .279.279h2.221l2.546 2.056a.28.28 0 0 0 .177.063.3.3 0 0 0 .119-.028.28.28 0 0 0 .16-.253v-7.464a.28.28 0 0 0-.162-.255",
  "data-name": "Tracciato 3597"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.981 29.802a.28.28 0 0 0-.046.393 3.3 3.3 0 0 1 0 3.992.28.28 0 0 0 .046.392.27.27 0 0 0 .173.062.28.28 0 0 0 .219-.107 3.87 3.87 0 0 0 0-4.685.28.28 0 0 0-.392-.047",
  "data-name": "Tracciato 3598"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.052 28.786a.28.28 0 0 0-.062.393 5.235 5.235 0 0 1 0 6.025.28.28 0 0 0 .062.39.3.3 0 0 0 .165.054.28.28 0 0 0 .226-.115 5.9 5.9 0 0 0 0-6.685.28.28 0 0 0-.391-.062",
  "data-name": "Tracciato 3599"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.909 27.17a.28.28 0 0 0-.066.389c.034.048 3.252 4.684 0 9.26a.28.28 0 0 0 .066.392.28.28 0 0 0 .162.05.28.28 0 0 0 .229-.116c3.479-4.9.035-9.858 0-9.908a.28.28 0 0 0-.391-.067",
  "data-name": "Tracciato 3600"
})))));
export default SvgPhone;